module.exports = __webpack_public_path__ + "img/icon-feed.d593497d.svg";